import React from 'react'
import Address from '../components/Address'
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
import Content from '../components/Content'

const Home = () => {
  return (
    <>
      {/* Address hidden on screens <= 992px */}
      <div className="d-none d-lg-block">
        <Address />
      </div>

      <Navigation />
      <Content />
      <Footer />
    </>
  )
}

export default Home
